export const BASE_URL = "https://sourcewhale.app";
export const UPLOAD_URL = "https://upload.sourcewhale.app";

export const isExtension = () =>
  typeof chrome !== "undefined" && chrome?.runtime?.id;
